
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/africa/content-library/category/[category]",
      function () {
        return require("private-next-pages/africa/content-library/category/[category].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/africa/content-library/category/[category]"])
      });
    }
  